import { Box } from "@mui/material"
import { useTranslationContext } from "./use-translation-context"

/**
 * Box that applies dir="rtl" when the current translation language is RTL.
 * Subscribes to TranslationStateChanged via useTranslationContext, so only
 * this component re-renders on translation changes — children pass through
 * unchanged (same reference from parent).
 */
export function TranslationDirBox({ children, ...props }) {
    const { rtl } = useTranslationContext()
    return (
        <Box dir={rtl ? "rtl" : undefined} {...props}>
            {children}
        </Box>
    )
}
